<template>
  <div class="companies">
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[
            { text: $t('meta.sites'), name: 'company_sites' },
            { text: site && site.name, name: 'site', params: { site_uuid: $route.params.site_uuid } },
            {
              text: zone && zone.area.name,
              name: 'area',
              params: { site_uuid: $route.params.site_uuid, area_uuid: $route.params.area_uuid },
            },
            { text: zone && zone.name },
          ]"
        />
      </template>
    </SectionHeader>
    <div class="body-content">
      <CompanyNav />
      <div class="body">
        <LoadingSpinner v-if="loading" />
        <div v-else>
          <ZoneForm :site="site" :area="zone.area" :initialZone="zone" @submit="updateZone" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ZoneForm from '@/views/companies/sites/areas/zones/ZoneForm'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import LoadingSpinner from '@/components/LoadingSpinner/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import sitesApi from '@/api/sites'
import zonesApi from '@/api/zones'

export default {
  name: 'company_zone',
  data: () => ({
    zone: null,
    site: null,
    loading: true,
  }),
  components: {
    ZoneForm,
    BreadCrumbs,
    CompanyNav,
    LoadingSpinner,
    SectionHeader,
  },
  async mounted() {
    this.zone = await zonesApi.get(this.$route.params.area_uuid, this.$route.params.zone_uuid)
    this.site = await sitesApi.get(this.$route.params.site_uuid)
    this.loading = false
  },
  methods: {
    async updateZone(zone) {
      const updatedZone = await zonesApi.update(this.$route.params.area_uuid, this.$route.params.zone_uuid, zone)

      if (updatedZone) {
        this.zone = updatedZone
      } else {
        // Don't let ZoneForm rerender in this case
      }
    },
  },
}
</script>
